import React, { useMemo } from 'react';
import { IntlProvider } from 'react-intl';

import NavigationHeader from '@alltrails/shared/components/NavigationHeader';
import { getLocale } from '@alltrails/shared/utils/languageSupport';
import Locale from '@alltrails/shared/types/Locale';
import { useSelector } from '../../redux/hooks';
import * as styles from './styles/styles.module.scss';

const Header = ({ fullpath }: { fullpath: string }): JSX.Element => {
  const { adminUser, displayMetric, currentUser, languageRegionCode, primaryAlgoliaIndexId } = useSelector(state => state.authState);
  const { dashboard: dashboardEnabled } = useSelector(state => state.enabledFeatures);
  const context = {
    adminUser,
    displayMetric,
    languageRegionCode,
    proUser: currentUser?.proUser,
    mobileBrowser: currentUser?.mobileBrowser,
    primaryAlgoliaIndexId: null as string,
    tabletBrowser: currentUser?.tabletBrowser,
    featureFlags: {}
  };

  const leftLinks = useMemo(() => {
    const links = [
      {
        label: 'Trails',
        href: '/portal',
        dataTestId: 'trails'
      },
      {
        label: 'Alerts',
        href: '/portal/alerts',
        dataTestId: 'alerts'
      }
    ];

    if (dashboardEnabled) {
      links.push({
        label: 'Dashboard',
        href: '/portal/dashboard',
        dataTestId: 'dashboard'
      });
    }

    return links.map(link => ({ ...link, isCurrentPage: fullpath === link.href }));
  }, [dashboardEnabled, fullpath]);

  const locale = getLocale(languageRegionCode);
  const customization = {
    leftLinks,
    helpLink: 'https://publiclandsportal.zendesk.com/hc/en-us'
  };

  return (
    <IntlProvider defaultLocale={Locale.English} locale={locale}>
      <NavigationHeader className={styles.header} context={context} user={currentUser} customization={customization} />
    </IntlProvider>
  );
};

export default Header;
